module.exports = __webpack_public_path__ + "static/media/ims.de6b5cbb.jpeg";